module.exports = __webpack_public_path__ + "img/actualitat-valenciana.dc060e5d.png";